export default __webpack_public_path__ + "static/media/icon_faction_hybrid.608e91f5.png";